let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cS6Vz")).then(() => parcelRequire('eD07d'));